import { Component, inject } from '@angular/core';
import { ConfigService } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-login-footer',
    templateUrl: './login-footer.component.html',
    styles: [],
    standalone: false,
})
export class LoginFooterComponent {
    private config = inject(ConfigService);
    copyright: string = this.config.get('copyright') || '';
    cookiePolicy?: string = this.config.get('cookiePolicy') || 'a57e434e';
    cookiePolicyUsCompliance: boolean = !!this.config.get('cookiePolicyUsCompliance');
}
